import { ComponentType } from 'react';

import EntryHome from 'uicontainers/apps/survey/entry/Home';
import FraudUI from 'uicontainers/apps/survey/Fraud';
import OnboardingHome from 'uicontainers/apps/survey/onboarding/Home';
import OnboardingRefresh from 'uicontainers/apps/survey_refresh/Onboarding';
import OnboardingConsultation from 'uicontainers/apps/consultations_refresh/Onboarding';
import QuotaUI from 'uicontainers/apps/survey/Quota';
import ScreenedUI from 'uicontainers/apps/survey/Screened';
import ScreenedRefreshUI from 'uicontainers/apps/survey_refresh/Screened';
import CustomBlockUI from 'uicontainers/apps/survey/CustomBlock';
import SurveyCompletedUI from 'uicontainers/apps/survey/SurveyCompleted';
import VerificationHome from 'uicontainers/apps/survey/verification/Home';
import QuotaUIRefresh from 'uicontainers/apps/survey_refresh/Quota';
import QuotaUIConsultation from 'uicontainers/apps/consultations_refresh/Quota';
import FraudRefresh from 'uicontainers/apps/survey_refresh/Fraud';
import FraudConsultation from 'uicontainers/apps/consultations_refresh/Fraud';
import Availability from 'uicontainers/apps/consultations_refresh/Availability';
import ContactInformation from 'uicontainers/apps/consultations_refresh/ContactInformation';
import Success from 'uicontainers/apps/consultations_refresh/Success';
import PaymentClaim from 'uicontainers/apps/consultations_refresh/PaymentClaim';

import { Block } from 'api/surveys/types';
import PaymentClaimRefresh from '../../../../uicontainers/apps/survey_refresh/PaymentClaim/PaymentClaim';

type BaseBlock = Exclude<Block, 'AVAILABILITY' | 'CONTACT'>;
type ExtraBlock = Extract<Block, 'AVAILABILITY' | 'CONTACT'>;

// Map type: all BaseBlock required, ExtraBlock optional
type BlockComponentMap = Record<BaseBlock, ComponentType> &
  Partial<Record<ExtraBlock, ComponentType>>;

export const BLOCK_TYPE_TO_COMPONENT_MAP: BlockComponentMap = {
  COMPLETED: SurveyCompletedUI,
  CUSTOM: CustomBlockUI,
  FRAUD: FraudUI,
  ONBOARDING: OnboardingHome,
  QUOTA: QuotaUI,
  SCREENED: ScreenedUI,
  VERIFICATION: VerificationHome,
  ENTRY: EntryHome,
};

export const BLOCK_TYPE_TO_COMPONENT_MAP_REFRESH: BlockComponentMap = {
  COMPLETED: PaymentClaimRefresh,
  CUSTOM: CustomBlockUI,
  FRAUD: FraudRefresh,
  ONBOARDING: OnboardingRefresh,
  QUOTA: QuotaUIRefresh,
  SCREENED: ScreenedRefreshUI,
  VERIFICATION: VerificationHome,
  ENTRY: EntryHome,
};

export const BLOCK_TYPE_TO_COMPONENT_MAP_CONSULTATION: BlockComponentMap = {
  COMPLETED: Success,
  CUSTOM: CustomBlockUI,
  FRAUD: FraudConsultation,
  ONBOARDING: OnboardingConsultation,
  QUOTA: QuotaUIConsultation,
  SCREENED: ScreenedRefreshUI,
  VERIFICATION: VerificationHome,
  AVAILABILITY: Availability,
  CONTACT: ContactInformation,
  ENTRY: EntryHome,
};

export const BLOCK_TYPE_TO_COMPONENT_MAP_CONSULTATION_AI: BlockComponentMap = {
  COMPLETED: PaymentClaim,
  CUSTOM: CustomBlockUI,
  FRAUD: FraudConsultation,
  ONBOARDING: OnboardingConsultation,
  QUOTA: QuotaUIConsultation,
  SCREENED: ScreenedRefreshUI,
  VERIFICATION: VerificationHome,
  AVAILABILITY: Availability,
  CONTACT: ContactInformation,
  ENTRY: EntryHome,
};
